module.exports = __webpack_public_path__ + "static/img/10.8300dd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/10.png
// module id = d99A
// module chunks = 0